/**
 * HeaderMenu用Script
 */
import $ from "jquery";

/* 実行Function 判定 */
export const runScriptByHeaderMenu = (currentRouteName: string) => {
    // ルート名からアクション名を除外
    const routeArray = currentRouteName.split(".");
    const routeName = routeArray[0];

    switch (routeName) {
        // ―― MasterMaintenance ――
        //  ユーザマスタメンテナンス
        case "user":
        //  車輌マスタメンテナンス
        case "car":
        //  車種マスタメンテナンス
        case "car_model":
        //  部署マスタメンテナンス
        case "department":
        //  保険会社マスタメンテナンス
        case "insurance_company":
        //  種別マスタメンテナンス
        case "type":
        //  使用目的マスタメンテナンス
        case "usage_objective":
        //  特約金額マスタメンテナンス
        case "special_contract_amount":
            addClassByMasterMaintenanceHeaderMenu();
            break;
        // ―― ./MasterMaintenance ――

        // ―― UserHoliday ――
        case "user_holiday":
        case "proxy_user_holiday":
            addClassByUserHolidayHeaderMenu();
            break;
        // ―― ./UserHoliday ――

        // ―― CarStatus ――
        case "car_status":
        case "car_inspection_status":
            addClassByCarStatusHeaderMenu();
            break;
        // ―― ./CarStatus ――

        // ―― Schedule ――
        case "schedule":
        case "schedule_csv":
        case "schedule_unset":
            addClassByScheduleHeaderMenu();
            break;
        // ―― ./Schedule ――
    }
};

/* 配車スケジュール */
const addClassByScheduleHeaderMenu = () => {
    $("#header_schedule").addClass("now");
};

/* 車輌状況 */
const addClassByCarStatusHeaderMenu = () => {
    $("#header_car_status").addClass("now");
};

/* 出勤状況 */
const addClassByUserHolidayHeaderMenu = () => {
    $("#header_user_holiday").addClass("now");
};

/* マスタメンテナンス */
const addClassByMasterMaintenanceHeaderMenu = () => {
    $("#header_master_maintenance").addClass("now");
};

/* グローバル関数を定義 */
(window as any).addClassByHeaderMenu = runScriptByHeaderMenu;
